module.exports = __webpack_public_path__ + "static/media/magic.6de31700.svg";